module.exports = __webpack_public_path__ + "img/empty-record-bg.fe29468.png";